module.exports = "/assets/779bdcf958b88766c481eb9f0f21fa14.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/G9.png
// module id = 1397
// module chunks = 0